import type { PhoneNumber } from '../../../services/phoneService';

export function formatPin(pin: string | null): string {
  if (!pin) {
    return '';
  }

  const digitsOnly = pin.replace(/[^0-9]/g, '');

  if (!digitsOnly) {
    return '';
  }

  const formatted = digitsOnly.match(/.{1,4}/g)?.join(' ') || digitsOnly;

  return formatted.endsWith('#') ? formatted : `${formatted}#`;
}

export function formatPinForTel(pin: string | null): string {
  if (!pin) {
    return '';
  }

  const digitsOnly = pin.replace(/[^0-9]/g, '');

  if (!digitsOnly) {
    return '';
  }

  return digitsOnly.endsWith('#') ? digitsOnly : `${digitsOnly}#`;
}

export const formatPhoneNumberForTel = (raw?: string | null) => raw?.replace(/[^0-9+]/g, '') ?? '';

export function getPrimaryPhoneNumber(phoneList: PhoneNumber[] | undefined): string | null {
  if (!phoneList || phoneList.length === 0) {
    return null;
  }

  const primaryPhone = phoneList.find((p) => p.countryCode === 'US' && !p.tollFree);
  return primaryPhone?.formattedNumber ?? null;
}
